import {ApolloLink} from 'apollo-link';

// These functions work with dynamic objects from GraphQL, where type safety is limited
type GraphQLObject = Record<string, unknown> | unknown[] | null | undefined;

export function omitDeep(obj: GraphQLObject, key: string): GraphQLObject {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) {
    return omitDeepArrayWalk(obj, key);
  }
  const keys = Object.keys(obj);
  const newObj: Record<string, unknown> = {};
  keys.forEach((i) => {
    if (i !== key) {
      const val = obj[i];
      if (Array.isArray(val)) {
        newObj[i] = omitDeepArrayWalk(val, key);
      } else if (typeof val === 'object' && val !== null) {
        newObj[i] = omitDeep(val as GraphQLObject, key);
      } else {
        newObj[i] = val;
      }
    }
  });
  return newObj;
}

export function omitDeepArrayWalk(arr: unknown[], key: string): unknown[] {
  return arr.map((val) => {
    if (Array.isArray(val)) {
      return omitDeepArrayWalk(val, key);
    } else if (typeof val === 'object' && val !== null) {
      return omitDeep(val as GraphQLObject, key);
    }
    return val;
  });
}

/**
 * An apollo link that removes __typename field from variables
 */
export const cleanTypenameLink = new ApolloLink((operation, forward) => {
  operation.variables = omitDeep(operation.variables as GraphQLObject, '__typename') as Record<
    string,
    unknown
  >;
  return forward(operation).map((data) => data);
});
